import React from "react";
import Imagen_pe from "../../../../new_images/Landing/Photos_Top/Photos_top_deliveryman.png";
import "./Envio.css";

class HazTuCamino extends React.Component {
  render() {
    return (
      <div id="apppage">
        <section>
          <div id="somos" className="row pe_container row-cols-1 row-cols-md-2">
            <div className="col-lg-6">
              <p className="pe_title">Servicio de Envío</p>
              <p className="pe_subtitle">
              Espera tus paquetes desde la comidad de tu hogar
              </p>
              <p className="pe_body">
              Llevamos y traemos tus paquetes para que no tengas que salir de la comodidad de tu hogar. 
              </p>
            </div>

            <div className="col-lg-5 col-md-12 col-sm-12">
              <img
                src={Imagen_pe}
                object-fit="width"
                width="100%"
                alt="logo"
              />
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default HazTuCamino;
